import { Component } from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import { connect } from 'react-redux';
import { addActivator, removeActivator } from 'actions/appProgress';

const mapDispatchToProps = {
  addActivatorAction: addActivator,
  removeActivatorAction: removeActivator
};

@connect(null, mapDispatchToProps)
export default class AppProgressActivator extends Component {
  static propTypes = {
    addActivatorAction: PropTypes.func.isRequired,
    removeActivatorAction: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.id = uniqueId('AppProgressActivator');
  }

  componentDidMount() {
    this.props.addActivatorAction(this.id);
  }

  componentWillUnmount() {
    this.props.removeActivatorAction(this.id);
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/AppProgress/Activator/index.js